import {useSelector} from 'react-redux';
import {selectCustomerPersonalizationKey} from 'coreStore/data/customer';

/**
 * useCustomerPersonalizationKey custom hook
 */
export default function useCustomerPersonalizationKey(): string|undefined {
	// Due to the specific of personalization and banning logic,
	// this selector is required to handle change of
	// assigned refinement customer groups
	return useSelector((state) => selectCustomerPersonalizationKey(state));
};
